import { useMutation, useQuery } from '@tanstack/react-query'
import type { ClinicRef, PortalDocument } from '@/features/appointments/api'
import { useApi } from '@/lib/api-context'

/**
 * O documento como a paciente o lê e baixa (docs/api/portal.md, `GET /portal/documents/:id` e
 * `/pdf`; RN-POR-06). Ler é o Markdown resolvido; baixar é a URL assinada de 15 minutos do PDF
 * protegido.
 */

export interface DocumentDetail extends PortalDocument {
  clinic: ClinicRef
  resolvedMarkdown: string | null
}

export interface PdfLink {
  url: string
  expiresAt: string
  fileName: string
  sizeBytes: number
  pageCount: number | null
}

export const documentKeys = {
  detail: (id: string) => ['portal', 'document', id] as const,
}

export function useDocument(id: string) {
  const api = useApi()
  return useQuery({
    queryKey: documentKeys.detail(id),
    queryFn: () => api.get<DocumentDetail>(`/portal/documents/${id}`),
  })
}

export function usePdfLink() {
  const api = useApi()
  return useMutation({
    mutationFn: (id: string) => api.get<PdfLink>(`/portal/documents/${id}/pdf`),
  })
}

/** Abre a URL assinada numa aba nova; o nome do arquivo é o da API (RN-DOC-28). */
export function openSignedUrl(url: string) {
  window.open(url, '_blank', 'noopener')
}
